module.exports = __webpack_public_path__ + "static/media/delivery.859b71e7.svg";